import {
  AssessmentType,
  MostRecentAssessmentAnswerNode,
} from "types/graphql-schema";
import { BasicUser } from "types/topicflow";

import useLabel from "@apps/use-label/use-label";

import { getQuestionClass } from "./question";
import { AssessmentQuestion } from "./types";

const AssessmentQuestionHeading = ({
  question,
  target,
  assessmentType,
  mostRecentAnswer,
  currentAnswer,
}: {
  question: AssessmentQuestion;
  target?: BasicUser | null;
  assessmentType?: AssessmentType;
  mostRecentAnswer?: Pick<
    MostRecentAssessmentAnswerNode,
    "integerAnswer" | "submitted"
  >;
  currentAnswer?: number;
}) => {
  const label = useLabel();
  const QuestionClass = getQuestionClass(question, { label });
  const questionTitleRightSide = QuestionClass.getTitleRightSide({
    target,
    assessmentType,
    mostRecentAnswer,
    currentAnswer,
  });
  const questionTitle = QuestionClass.getTitle();
  const questionDescription = QuestionClass.getDescription();
  return (
    <>
      <div className="w-full flex items-start gap-4">
        {questionTitle}
        {questionTitleRightSide}
      </div>
      {questionDescription}
    </>
  );
};

export default AssessmentQuestionHeading;
